import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { conferences } from '../data/conferences';
import './newsupdates.css'; // Assuming you have a CSS file for styling
import Footer from '../components/Footer';

const NewsUpdatesPost = () => {
    const { postId } = useParams();

    // Find the post and its index
    const post = conferences.find(c => c.id === parseInt(postId));


    const currentIndex = conferences.findIndex(c => c.id === parseInt(postId));

    if (!post) {
        return <h2>Post not found!</h2>;
    }

    const prevPost = currentIndex > 0 ? conferences[currentIndex - 1] : null;
    const nextPost = currentIndex < conferences.length - 1 ? conferences[currentIndex + 1] : null;

    return (
        <>
        {/* 1. Full-width Hero Image Section */}
            <div className="hero-section text-center text-white mb-5" style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('${post.MainImage}')`, // Replace with your hero image
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '100px 0',
                minHeight: '40vh',
                display: 'flex',
                alignItems: 'flex-end', // Changed to push content to the bottom
                justifyContent: 'center'
            }}>
                <h1 className='text-white'>{post.Title}</h1>
            </div>

            <div className="post-detail-page">
            <h1 className="post-title">{post.Title}</h1>

            <div className="post-content">
                {post.content.map((item, index) => {
                    switch (item.Type) {
                        case 'BannerImage':
                            return <img key={index} src={item.url} alt="Banner" className="banner-image my-5" />;
                        case 'Text':
                            return (
                                <div key={index} className="text-content py-3">
                                    <h2>{item.Header}</h2>
                                    <div dangerouslySetInnerHTML={{ __html: item.text }} />
                                </div>
                            );
                        case 'Gallery':
                            return (
                                <div key={index} className="gallery-section">
                                    <div className="gallery-grid">
                                        {item.images.map((image, imgIndex) => (
                                            <figure key={imgIndex} className="gallery-item">
                                                <img src={image.imageUrl} alt={image.description || 'Gallery image'} />
                                                {image.description && <figcaption>{image.description}</figcaption>}
                                            </figure>
                                        ))}
                                    </div>
                                    {item.description && <p className="gallery-description">{item.description}</p>}
                                </div>
                            );
                        default:
                            return null;
                    }
                })}
            </div>

            <div className="navigation-buttons">
                {prevPost ? (
                    <Link to={`/news-updates/${prevPost.id}`} className="nav-button prev">
                        &larr; Previous
                        <span className="nav-title">{prevPost.Title}</span>
                    </Link>
                ) : (
                    <div /> // Placeholder for alignment
                )}
                {nextPost ? (
                    <Link to={`/news-updates/${nextPost.id}`} className="nav-button next">
                        Next &rarr;
                        <span className="nav-title">{nextPost.Title}</span>
                    </Link>
                ) : (
                    <div /> // Placeholder for alignment
                )}
            </div>
            <Link to="/news-updates" className="back-to-list-button">Back to All Posts</Link>
        </div>

        <Footer />
        </>
        
    );
};

export default NewsUpdatesPost;